<template>
  <div class="container min-vh-100">
    <div class="row min-vh-100">
      <div class="col-md-4 m-auto">
        <section class="row">
          <div class="col-12">
            <img
              src="/img/logo.jpg"
              class="img-logo img-responsive mb-3"
              alt="logo"
            />
            <h5 class="text-center text-muted login">CBA Sucre</h5>
            <p>
              Ingrese su dirección de correo electrónico para recuperar su
              contraseña.
            </p>
            <div class="alert alert-danger" role="alert" v-if="response.error">
              <strong>{{ response.message }}</strong>
            </div>
            <div
              class="alert alert-success"
              role="alert"
              v-if="response.success"
            >
              <strong>{{ response.message }}</strong>
            </div>
          </div>
        </section>
        <ValidationObserver ref="form" v-slot="{ invalid }">
          <form @submit.prevent="recoverPassword">
            <section class="row">
              <div class="col-12">
                <div class="form-group">
                  <ValidationProvider
                    name="email"
                    rules="required|email|max:180"
                    :debounce="500"
                    v-slot="{ valid, errors }"
                  >
                    <label for="email" class="col-form-label text-md-right"
                      >Correo electrónico</label
                    >
                    <input
                      v-model="user.email"
                      autofocus
                      type="email"
                      placeholder="Correo electrónico"
                      class="form-control"
                      maxlength="180"
                    />
                    <b-form-invalid-feedback :state="valid">{{
                      errors[0]
                    }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </div>
              </div>
            </section>
            <div class="form-group row">
              <div class="col-12">
                <button
                  type="submit"
                  class="btn btn-block btn-primary"
                  variant="success"
                  :disabled="invalid || addLoader"
                >
                  <span v-if="!addLoader">Recuperar contraseña </span>
                  <span v-if="addLoader">
                    Cargando
                    <CSpinner color="success" size="sm" />
                  </span>
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormInvalidFeedback } from "bootstrap-vue";
import { Utils } from "@/plugins/utils";
import { extend } from "vee-validate";
import { required, email, max, min } from "vee-validate/dist/rules";
import Auth from "@/plugins/services/auth";
import Mail from "@/plugins/services/mail";

export default {
  name: "RecoverPassword",
  components: { BFormInvalidFeedback },
  data() {
    return {
      user: {
        email: "",
      },
      response: {
        error: false,
        success: false,
        message: "",
      },
      addLoader: false,
    };
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido.",
    });

    extend("email", {
      ...email,
      message: "El email tiene un formato incorrecto.",
    });

    extend("max", {
      ...max,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como máximo.",
    });

    extend("min", {
      ...min,
      params: ["length"],
      message: "El campo debe tener {length} caracteres como mínimo.",
    });
  },
  methods: {
    recoverPassword() {
      this.addLoader = true;
      this.response = {
        error: false,
        success: false,
        message: "",
      };
      Auth.csrf(this.user)
        .then((res) => {
          Mail.recover(this.user)
            .then((res) => {
              this.addLoader = false;
              this.response.success = true;
              this.response.message = res.data.message;
            })
            .catch((err) => {
              this.addLoader = false;
              this.response.error = true;
              if (err.response && err.response.status == 422) {
                this.response.message = err.response.data.message;
              }
              if (err.response && err.response.status == 500) {
                this.response.message = err.response.data.message;
              }
            });
        })
        .catch((err) => {
          Utils.setFlash("danger", "Error " + err);
        });
    },
  },
};
</script>
